/**
 * FSM states that require an editable prompt in the dialog template.
 *
 * This is a SUBSET of the full voice-gateway FSM (`voice-gateway/src/Fsm/states.ts`).
 * The full FSM also has WAIT_* (silent listening for STT), CONFIRMING_* (silent waiting
 * for CI4), IDLE, and COMPLETE_OR_NEXT transition states — none of which speak to the
 * operator, so they don't need a prompt configured here.
 *
 * Operator workflow per pick task (riferimento: voice-gateway machine.ts):
 *   FETCH_NEXT_TASK → SAY_LOCATION → (WAIT_LOCATION_CONFIRM / CONFIRMING_LOCATION)
 *                  → SAY_ITEM_NAME → (WAIT_DISCRIMINATOR_CONFIRM / CONFIRMING_DISCRIMINATOR)
 *                  → SAY_QTY      → (WAIT_QTY_CONFIRM / CONFIRMING_QUANTITY)
 *                  → COMPLETE_OR_NEXT → next task or MISSION_COMPLETE.
 *
 * SAY_FORCE_PROMPT è il prompt di conferma quando l'operatore dice `FORZA <numero>`.
 * FALLBACK_INPUT è lo stato in cui finisce il flow dopo max_retries.
 * CANCEL_FLOW è lo stato di chiusura quando l'operatore dice `CANCEL_MISSION`.
 *
 * Le retry sono governate da retry_policy (max_retries, default 2). Su retry il voice-gateway
 * ri-emette il prompt SAY_* corrente — NON c'è un prompt "RETRY_*" separato.
 */
export const FSM_STATES = [
  'FETCH_NEXT_TASK',
  'SAY_LOCATION',
  'SAY_ITEM_NAME',
  'SAY_QTY',
  'SAY_FORCE_PROMPT',
  'FALLBACK_INPUT',
  'MISSION_COMPLETE',
  'CANCEL_FLOW',
] as const;

export type FsmState = typeof FSM_STATES[number];

/** Subset that MUST have a non-empty prompt to save a dialog template. */
export const REQUIRED_FSM_STATES: ReadonlyArray<FsmState> = [
  'SAY_LOCATION',
  'SAY_ITEM_NAME',
  'SAY_QTY',
  'FALLBACK_INPUT',
  'MISSION_COMPLETE',
];
